import { themes, Theme } from '@redis-ui/styles';

export const themeUi: Theme = themes.dark;
